module.exports = __webpack_public_path__ + "media/moneyout.a4a6d99d.mp3";